export default __webpack_public_path__ + "static/arrow-plans-a040f6ea3935ae1c12b2a7e4134697aa.svg";